import { FormPanelComponent, type FormPanelComponentProps } from 'app/components/form-panel/FormPanelComponent'

/**
 * @deprecated Use FormPanelShadcnComponent from 'app/components/form-panel'
 */
export default function FormPanel(props: FormPanelComponentProps) {
  return <FormPanelComponent {...props} />
}
